import { createTranslations } from '@npco/utils-translations'

export const timezoneMessageTranslations = createTranslations({
  timezoneInfo: 'Based on {timezone} time.',
  timezoneInfoFallback:
    'Reset time is based on registered business location time.',
})
